import { render, staticRenderFns } from "./Contact_components.vue?vue&type=template&id=1006ca59&scoped=true&"
import script from "./Contact_components.vue?vue&type=script&lang=js&"
export * from "./Contact_components.vue?vue&type=script&lang=js&"
import style0 from "./Contact_components.vue?vue&type=style&index=0&id=1006ca59&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1006ca59",
  null
  
)

export default component.exports